import { StrictMode } from 'react';
import { render } from 'react-dom';

import Debugger from './components/Debugger';
import { GraphQLQuery } from './types';

let queries: GraphQLQuery[] = [];

const debuggerRoot = document.createElement('div');
debuggerRoot.setAttribute('id', 'debugger-root');
document.body.appendChild(debuggerRoot);

export function intercept(query: GraphQLQuery) {
  if (!query.response.extensions) return;

  queries = [...queries, query];

  render(
    <StrictMode>
      <Debugger data={queries} />
    </StrictMode>,
    debuggerRoot
  );
}
